
// TODO: Determine how / where to store this mock data, this is really not ideal
// Helper for generating mock product entries used in landing page and search fixtures
const makeMockProduct = (id: number, name: string) => ({
	id,
	name,
	id_string: `MP${id}`,
	is_approved: true,
	is_featured: true,
	files: [],
	display_image: [],
	materials: [],
	categories: [],
	collaborators: [],
	tags: []
});

export const landing_page_data = {
	'data': {
		'categories': [
			{
				'type': 'patient_specific_products',
				'categories': [
					{
						'id': 22,
						'name': 'Caps and Connectors',
						'description': null,
						'image_path': null,
						'bucket_name': null,
						'has_products': true
					},
					{
						'id': 29,
						'name': 'Clips and Clamps',
						'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
						'image_path': null,
						'bucket_name': null,
						'has_products': true
					}
				]
			},
			{
				'type': 'professional_services',
				'categories': [
					{
						'id': 21,
						'name': 'Containers',
						'description': null,
						'image_path': null,
						'bucket_name': null,
						'has_products': true
					},
					{
						'id': 10,
						'name': 'Organizational Tools',
						'description': null,
						'image_path': null,
						'bucket_name': null,
						'has_products': false
					}
				]
			}
		]
	}
};

export const user_data = {
	'data': {
		'id': 1,
		'display_name': 'Clark Oake',
		'email': 'clark@polyunity.com',
		'id_string': 'mfAon52wXGbi06kH4YsU0jQAKZI3',
		'organisation': {
			'id': 22,
			'name': 'CHEO (Children\'s Hospital of Eastern Ontario)',
			'short_name': 'cheo'
		},
		'addresses': [
			{
				'id': 1,
				'name': 'Main Hospital',
				'street_address': '401 Smyth Road',
				'city': 'Ottawa',
				'province': 'ON',
				'postal_code': 'K1H 8L1',
				'country': 'Canada',
				'consignee': 'Clark Oake',
				'delivery_instructions': 'Leave at reception desk'
			}
		]
	}
};

export const account_page_data = {
	'data': [
		{
			'id': 1,
			'name': 'polyunity_admin'
		},
		{
			'id': 2,
			'name': 'org_admin'
		},
		{
			'id': 3,
			'name': 'org_auditor'
		},
		{
			'id': 4,
			'name': 'department_manager'
		},
		{
			'id': 5,
			'name': 'user'
		}
	]
};

export const cart_data = {
	'data': [
		{
			'product_id': 2635,
			'department_id': 583,
			'quantity': 1,
			'user_id': 2649,
			'note': '',
			'product': {
				'name': 'notAProduct',
				'id_string': 'C002',
				'file_required': false,
				'is_approved': false,
				'remaining_quantity': null,
				'price': 0,
				'pending_order_items': null,
				'images': [],
				'materials': [
					{
						'id': 1,
						'name': 'Silicone',
						'quantity': null
					},
					{
						'id': 2,
						'name': 'PLA',
						'quantity': null
					}
				]
			},
			'department': {
				'id': 583,
				'name': 'Marketing',
				'client_id': 'not mapped'
			}
		},
		{
			'product_id': 2810,
			'department_id': 147,
			'quantity': 1,
			'user_id': 2649,
			'note': '',
			'product': {
				'name': 'Rear Hanger Hook for P500 Therapy Air Surface',
				'id_string': 'C152B',
				'file_required': false,
				'is_approved': false,
				'remaining_quantity': null,
				'price': null,
				'pending_order_items': null,
				'images': [],
				'materials': [
					{
						'id': 2,
						'name': 'PLA',
						'quantity': 8
					}
				]
			},
			'department': {
				'id': 147,
				'name': 'Orthopedics',
				'client_id': ''
			}
		},
		{
			'product_id': 2635,
			'department_id': 147,
			'quantity': 3,
			'user_id': 2649,
			'note': '  ',
			'product': {
				'name': 'notAProduct',
				'id_string': 'C002',
				'file_required': false,
				'is_approved': false,
				'remaining_quantity': null,
				'price': 0,
				'pending_order_items': null,
				'images': [],
				'materials': [
					{
						'id': 1,
						'name': 'Silicone',
						'quantity': null
					},
					{
						'id': 2,
						'name': 'PLA',
						'quantity': null
					}
				]
			},
			'department': {
				'id': 147,
				'name': 'Orthopedics',
				'client_id': ''
			}
		}
	]
};

export const user_idea_data = {
	'data': [
		{
			'id': 2690,
			'created_on': '2023-12-07T19:47:43.995Z',
			'is_dummy': false,
			'idea_information': 'wrggsg',
			'reason': 'wrgrgrg',
			'suggested_name': 'wrgagae',
			'reusable': false,
			'id_string': null,
			'date_triaged': null,
			'reviewed_on': '2024-04-23T18:07:13.895Z',
			'is_estimate_approved': true,
			'date_requested': '2023-12-07 19:47:43.995843+00',
			'estimated_cost': null,
			'sanitizations': [],
			'files': [],
			'child_products': [],
			'hidden_products': [],
			'reviewer': {
				'id': 223,
				'display_name': 'Clark Oake'
			}
		},
		{
			'id': 2612,
			'created_on': '2023-08-02T14:37:13.634Z',
			'is_dummy': false,
			'idea_information': 'bd vacutainer racks',
			'reason': '',
			'suggested_name': '',
			'reusable': false,
			'id_string': null,
			'date_triaged': null,
			'reviewed_on': null,
			'is_estimate_approved': null,
			'date_requested': '2023-05-16 11:21:31.374+00',
			'estimated_cost': null,
			'sanitizations': [],
			'files': [],
			'child_products': [],
			'hidden_products': [],
			'reviewer': null
		}
	]
};

export const idea_form_data = {
	'message': 'Successfully retrieved data',
	'data': {
		'specifications': [],
		'statuses': [],
		'sanitizations': [],
		'organisations': [],
		'assignees': [],
		'all_shelved_reasons': [],
		'idea_categories': [
			{ id: 1, name: 'Medical Device' },
			{ id: 2, name: 'Surgical Tool' },
			{ id: 3, name: 'Organizational Tool' },
			{ id: 4, name: 'Patient Care' },
			{ id: 5, name: 'Training Aid' }
		],
		'opportunity_windows': [
			{ id: 1, name: '< 1 Week' },
			{ id: 2, name: '1-4 Week(s)' },
			{ id: 3, name: '2-3 Months' },
			{ id: 4, name: '3-6 Months' },
			{ id: 5, name: '6+ Months' }
		],
		'expected_quantity': [
			{ id: 1, name: '<10' },
			{ id: 2, name: '10-20' },
			{ id: 3, name: '21-50' },
			{ id: 4, name: '50-100' },
			{ id: 5, name: '100+' }
		],
		'departments_impacted': [
			{ id: 1, name: '1 (My Department Only)' },
			{ id: 2, name: '2-3' },
			{ id: 3, name: '4-9' },
			{ id: 4, name: '10+' }
		]
	}
};

export const org_depts_data = {
	'message': 'Successfully retrieved data',
	'data': [
		{
			'id': 44,
			'created_on': '2023-04-22T15:09:38.580Z',
			'created_by': 1,
			'changed_on': '2024-09-18T16:23:43.405Z',
			'changed_by': 284,
			'is_deleted': false,
			'name': 'Endocrinology',
			'id_string': 'endocrinology_polyunity',
			'organisation_id': 11,
			'organisation_string': 'polyunity',
			'client_id': '',
			'client_name': 'Endocrinology',
			'current_approver_id': 54,
			'department_users': [
				{
					'id': 149,
					'display_name': 'Sydney Newton',
					'email': 'sydney.newton@polyunity.com',
					'is_budget_approver': false,
					'is_product_approver': false
				},
				{
					'id': 1086,
					'display_name': 'Sydney Test',
					'email': 'sydney.newton+testprod@polyunity.com',
					'is_budget_approver': false,
					'is_product_approver': false
				}
			],
			'current_approvers': [
				{
					'id': 37,
					'display_name': 'Dan Brake',
					'email': 'dan@polyunity.com',
					'is_budget_approver': true,
					'is_product_approver': true
				}
			]
		}
	]
};

export const product_data = {
	'message': 'Successfully retrieved Product data',
	'data': {
		'id': 2641,
		'created_on': '2023-03-22T12:33:05.669Z',
		'created_by': 1,
		'changed_on': '2024-06-05T13:56:52.397Z',
		'changed_by': 2649,
		'story': '',
		'catalog_description': 'Extender for PolyUnity Procedural Face Shields. Provides extra space between face and shield for Loupes.',
		'approval_reason': '',
		'name': 'Samson Microphone Stand',
		'status': {
			'id': 8,
			'name': 'SHELVED'
		},
		'default_design_hrs': 0,
		'default_print_hrs': 0,
		'default_labour_hrs': 0,
		'date_completed_on': null,
		'parent_product_id': null,
		'id_string': 'C008',
		'design_note': 'Shelved: no longer needed by requestors',
		'compatible_product': null,
		'operating_conditions': '< 40°C',
		'product_price': 22,
		'file_required': false,
		'approval_description': '',
		'third_party_org_id': null,
		'compatible_equipment': null,
		'total_delivery_design_hrs': 46,
		'timesheet_hours': null,
		'o': [
			{
				'id': 22,
				'print_per_hr': 12,
				'labour_per_hr': 140
			}
		],
		'pending_order_items': null,
		'product_approvals': [],
		'catalogs': [],
		'files': [],
		'categories': [
			{
				'id': 10,
				'name': 'Organizational Tools'
			}
		],
		'materials': [
			{
				'id': 2,
				'name': 'PLA',
				'quantity': null
			}
		],
		'collaborators': [],
		'assigned_to': {
			'id': 321,
			'name': ''
		},
		'tags': [
			{
				'id': 2,
				'name': 'INNOVATE'
			}
		],
		'links': [
			{
				'id': 726,
				'name': 'Samson Microphone Stand',
				'path': 'test',
				'type': 'link'
			}
		],
		'organisations': [
			{
				'id': 22,
				'name': 'CHEO (Children\'s Hospital of Eastern Ontario)',
				'is_featured': true
			},
			{
				'id': 25,
				'name': 'PolyUnity Tech Inc.',
				'is_featured': false
			}
		],
		'children': [],
		'supplier': {
			'id': 25,
			'name': 'PolyUnity Tech Inc.'
		},
		'parent': null,
		'completor': null,
		'ideas': [
			{
				'id': 2190,
				'is_dummy': false,
				'submitted_by_department_id': 54,
				'submitted_by': 283,
				'id_string': 'C008',
				'level_of_effort': 1,
				'name': 'Samson Microphone Stand',
				'submitted_by_org_id': 22,
				'submitter_name': 'Oem Dave',
				'department_name': 'Biomedical'
			}
		],
		'order_with': [],
		'related_products': [],
		'product_files': [],
		'case_study': null,
		'approved_in_orgs': [],
		'carts': [],
		'originating_idea': {
			'id': 2190,
			'is_dummy': false,
			'submitted_by': 283,
			'id_string': 'C008',
			'level_of_effort': 1,
			'name': 'Samson Microphone Stand',
			'submitter': {
				'id': 283,
				'name': 'test'
			},
			'department': {
				'id': 54,
				'name': 'Biomedical',
				'organisation_id': 22
			}
		},
		'form_collection_path': null,
		'price': 22,
		'is_approved': false,
		'remaining_quantity': null
	}
};

export const order_form_data = {
	'message': 'Successfully retrieved form data',
	'data': {
		'equipments': [],
		'addresses': [],
		'organisations': [],
		'materials': [],
		'statuses': [],
		'related_idea_join': {
			'idea_id': 2190,
			'product_id': 2641,
			'default_receiver': []
		},
		'items': []
	}
};

export const category_data = {
	'message': 'Successfully retrieved data',
	'data': [
		{
			'type': 'patient_specific_products',
			'categories': [
				{ 'id': 22, 'name': 'Containers' },
				{ 'id': 27, 'name': 'Otolaryngology (ENT)' },
				{ 'id': 6, 'name': 'Fixation Devices' },
				{ 'id': 7, 'name': 'Splints and Casts' },
				{ 'id': 13, 'name': 'Replacement Parts' }
			]
		},
		{
			'type': 'professional_services',
			'categories': [
				{ 'id': 20, 'name': 'Services' }
			]
		}
	]
};

export const status_data = {
	'message': 'Successfully retrieved data',
	'data':  {
		'ideastatus': [
			{
				'name': 'ARCHIVED'
			},
			{
				'name': 'CONTACTED'
			},
			{
				'name': 'NEW'
			},
			{
				'name': 'PROMOTED'
			},
			{
				'name': 'SHELVED'
			},
			{
				'name': 'TRIAGE'
			}
		],
		'productstatus': [
			{
				'name': 'ARCHIVED'
			},
			{
				'name': 'COMPLETE'
			},
			{
				'name': 'DEVELOPMENT'
			},
			{
				'name': 'LAUNCH PREP'
			},
			{
				'name': 'RE-EVALUATING'
			},
			{
				'name': 'SHELVED'
			},
			{
				'name': 'USER TESTING'
			}
		],
		'orderstatus': [
			{
				'name': 'CANCELLED'
			},
			{
				'name': 'DELIVERED'
			},
			{
				'name': 'DELIVERING'
			},
			{
				'name': 'IN PROGRESS'
			},
			{
				'name': 'NEW'
			},
			{
				'name': 'DESIGN READY'
			}
		]
	}
};

/**
 * Mock successful idea creation response
 * Matches the DeepIdea interface structure for successful idea submissions
 * Used by:
 * - MSW handlers in src/tests/msw/handlers.ts for Jest contract tests
 * - Playwright handlers for E2E tests
 * - IdeaSubmission.contract.test.tsx for payload validation
 */
export const create_idea_success_response = {
	'message': 'Successfully created idea',
	'data': {
		'id': 9999,
		'suggested_name': 'Test Product Name',
		'idea_information': 'Test description for the idea submission',
		'reason': 'Test justification for the idea',
		'status': 1, // IdeaStatuses.NEW = 1
		'idea_status': {
			'id': 1,
			'name': 'NEW'
		},
		'created_on': new Date().toISOString(),
		'is_urgent': false,
		'reusable': false,
		'categories': [],
		'files': [],
		'sanitizations': [],
		'child_products': [],
		'submitter': {
			'id': 1,
			'display_name': 'Clark Oake'
		},
		'department': {
			'id': 54,
			'name': 'Biomedical',
			'organisation_id': 22
		}
	}
};

/**
 * Mock error response for failed idea creation
 * Used for testing error handling scenarios in contract and E2E tests
 */
export const create_idea_error_response = {
	'message': 'Failed to create idea',
	'error': 'Validation error: required fields missing'
};

/**
 * Mock response for retrieving user ideas list
 * Reuses existing user_idea_data for consistency with existing mock patterns
 * Used by MSW handlers for getIdeasSecondGen endpoint
 */
export const get_ideas_response = {
	'message': 'Successfully retrieved data',
	'data': user_idea_data.data
};

// ── Search results mock data for E2E infinite scroll tests ──────────────────
// Generates paginated search results matching LandingPageSearchData interface
const makeSearchProduct = (id: number) => ({
	...makeMockProduct(id, `Search Product ${id}`),
	is_featured: false,
	catalog_price: 10 + id,
	display_category: 'Test Category'
});

const searchPage1Items = Array.from({ length: 24 }, (_, i) => makeSearchProduct(i + 1));
const searchPage2Items = Array.from({ length: 24 }, (_, i) => makeSearchProduct(i + 25));
const searchPage3Items = Array.from({ length: 24 }, (_, i) => makeSearchProduct(i + 49));
const searchPage4Items = Array.from({ length: 4 }, (_, i) => makeSearchProduct(i + 73));

export const search_results_pages: Record<string, { items: unknown[]; total_results: number; nextCursor: string | null }> = {
	'null': { items: searchPage1Items, total_results: 76, nextCursor: 'cursor_page_2' },
	'cursor_page_2': { items: searchPage2Items, total_results: 76, nextCursor: 'cursor_page_3' },
	'cursor_page_3': { items: searchPage3Items, total_results: 76, nextCursor: 'cursor_page_4' },
	'cursor_page_4': { items: searchPage4Items, total_results: 76, nextCursor: null }
};

export const search_results_empty = {
	items: [],
	total_results: 0,
	nextCursor: null
};

export const mockDatabaseData = () => {
	const { fetch: original_fetch } = window;
	window.fetch = async (...args) => {
		const [url] = args;

		const endpoint = (url as string).replace('http://127.0.0.1:5001/poly-dev-cmsd/northamerica-northeast1/', '');
		console.log('fetch intercepted for endpoint:', endpoint);

		const matchedMockResponse = Object.keys(mockResponses).find((key) => endpoint.startsWith(key));

		if (matchedMockResponse) {
			/* mock the response: */
			return new Response(JSON.stringify(mockResponses[matchedMockResponse]));
		} else {
			/* or work with the cloned response in a separate promise
			chain -- could use the same chain with `await`. */
			const response = await original_fetch(...args);

			response
				.clone()
				.json()
				.then((data) => console.log('intercepted response data:', data))
				.catch((err) => console.error(err));

			/* the original response can be resolved unmodified: */
			return response;
		}
	};
};

const mockResponses: any = {
	'getUser': user_data,
	'getCart': cart_data,
	'getIdeas': user_idea_data,
	'getLandingPage': landing_page_data,
	'getOrgDepts': org_depts_data,
	'getStatuses': status_data,
	'getCatalogCategories': category_data
};

// TODO: determine how we can mock Firestore (or at least its queries) for testing
interface MockResponse {
    status: number;
    contentType: string;
    headers: Record<string, string>;
    body?: string;
}

// Default response object for successful mock API requests
const mockResponse: MockResponse = {
	status: 200,
	contentType: 'application/json',
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE,OPTIONS',
		'Access-Control-Allow-Headers': 'Content-Type, Authorization'
	}
};

// TODO: We may need to review how we are matching URLs for better accuracy
const mockAPIRoutes: Record<string, MockResponse> = {
	'/getLandingPage': {
		...mockResponse,
		body: JSON.stringify(landing_page_data)
	},
	'/getAllUserRoles': {
		...mockResponse,
		body: JSON.stringify(account_page_data)
	},
	'/getUserIdeas': {
		...mockResponse,
		body: JSON.stringify(user_idea_data)
	},
	'/getUser': {
		...mockResponse,
		body: JSON.stringify(user_data)
	},
	'/getIdeaFormSecondGen': {
		...mockResponse,
		body: JSON.stringify(idea_form_data)
	},
	'/getCart': {
		...mockResponse,
		body: JSON.stringify(cart_data)
	},
	'/getOrgDepts': {
		...mockResponse,
		body: JSON.stringify(org_depts_data)
	},
	'/getProductSecondGen': {
		...mockResponse,
		body: JSON.stringify(product_data)
	},
	'/getOrderForm': {
		...mockResponse,
		body: JSON.stringify(order_form_data)
	}
};

// TODO: Fix typing on this
export async function setupRequestInterception(page: any, mocks = mockAPIRoutes) {
	await page.setRequestInterception(true);

	page.on('request', (interceptedRequest: any) => {
		const url = interceptedRequest.url();

		// Check if the request matches one of the mock endpoints
		const mockKey = Object.keys(mocks).find((key) => url.includes(key));
		if (mockKey) {
			// console.log(`Mocking request for: ${mockKey}`);  
			interceptedRequest.respond(mocks[mockKey]);
		} else {
			interceptedRequest.continue();
		}
	});
}

